import React from 'react';
import styled from 'styled-components';
import LiveHeader from './LiveHeader';
import _get from 'lodash/get';
import { breakPoints } from '../config';
import liveIcon from '../assets/live-icon.svg';
import { setup } from '../config';

const { enablePLive, pLiveHref } = setup;

const _ = {
  get: _get,
};

const { maxMobile } = breakPoints;

const Container = styled.div`
  @media(max-width: ${breakPoints.maxMobile}px) {
    margin: 32px 0;
  }
`;

const UL = styled.ul`
  background-color: #FFFFFF;
  list-style: none;
  padding: 16px;
  border-top: 2px solid ${props => props.theme.blue};
`;

const Li = styled.li`
  padding: 10px 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  &:before {
    display: inline-block;
    width: 0;
    height: 0;
    border-top: solid transparent;
    border-bottom: solid transparent;
    border-left: solid ${props => props.theme.blue};
    border-width:	5px;
    content: '';
    margin-right:	5px;
}`;

const ImageWrapper = styled.div`
  width: 20px;
  height: 20px;
  > img {
    display: block;
    height: 100%;
    width: 100%;
  }
`;

const LiveContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 30px;
  margin-bottom: 11px;
  a {
    &:link {
      cursor: ${props => props.enablePLive ? 'pointer' : 'default'};
      pointer-event: none;
      color: #808080;
      text-decoration: none;
      transition: 0.3s;
      border-bottom: 1px solid transparent;
    }
    &:hover {
      pointer-event: none;
      color: #808080;
      transition: 0.3s;
      border-bottom: 1px solid ${props => props.enablePLive ? '#808080' : 'transparent'};
    }
    &:visited {
      pointer-event: none;
      color: #808080;
    }
  }
`;

const LiveContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const LiveIconComp = () => {
  return (
    <LiveContainer
      enablePLive={enablePLive}
    >
      <a
        href={enablePLive ? `${pLiveHref}` : '/'}
        target={enablePLive ? '_blank' : '_self'}
        rel="noopener noreferrer"
      >
        <LiveContent>
          <ImageWrapper>
            <img src={liveIcon} alt="live play icon " />
          </ImageWrapper>
          <span>【PLive】開票影音直播 </span>
        </LiveContent>
      </a>
    </LiveContainer>
  );
}

function KeyEvent ({
  total,
  keyEventList,
  blockList,
  onClickEvent,
  targetId,
}) {

  const onClickHandler = ({
    e,
    targetId: localTargetId,
  }) => {
    if (localTargetId !== targetId) {
      onClickEvent({
        targetId: localTargetId,
      })
    } else {
      const elem = document.getElementById(targetId);
      if (window && elem) {
        let offset = 0;
        if (window && document && window.innerWidth <= maxMobile) {
          offset = _.get(document.getElementById('infographic'), 'offsetHeight', 0);
        }
        let target = window.pageYOffset + elem.getBoundingClientRect().top - offset;
        window.scrollTo({
          top: target + 1,
          behavior: 'smooth'
        });
      }
    }
  }

  const content = keyEventList.map((elem, index) => {
    const { text, timestamp } = elem;
    return (
      <Li
        key={`keyevent_${timestamp}_${text}`}
        onClick={(e) => {
          onClickHandler({
            targetId: timestamp,
            e,
          })
        }}
      >
        <h4>
          {text}
        </h4>
      </Li>
    )
  });

  return (
    <Container>
      <LiveIconComp />
      <LiveHeader
        text="關鍵事件"
      />
      <UL>
        {content}
      </UL>
    </Container>
  )
}

export default KeyEvent;
